'use client';

import { useRouter } from 'next/navigation';
import type { PlayersLeaderboardAlltimeDtoPaginatedList } from '@/api/backoffice-schemas';
import { TournamentsLeaderboardTable } from '@/components/pickems/tournaments/TournamentsLeaderboardTable';
import type { Tournament } from '@/types/tournament';
import { getTournamentPath } from '@/utils/paths';

export function TournamentsLeaderboardTableWrapper({
  data,
  tournament,
}: {
  data: PlayersLeaderboardAlltimeDtoPaginatedList;
  tournament: Tournament;
}) {
  const router = useRouter();

  function onPageChange(page: number): void {
    router.push(
      `${getTournamentPath({
        game: tournament.game,
        slug: tournament.slug,
      })}/leaderboard?page=${page}`
    );
  }
  return (
    <TournamentsLeaderboardTable data={data} onPageChange={onPageChange} />
  );
}
